import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { LeavePromoDetailPage } from './leave-promo-detail.page';
import { ModuleSharedModule } from "../../modules/module-shared.module";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ModuleSharedModule,
  ],
  declarations: [LeavePromoDetailPage],
  exports: [LeavePromoDetailPage],
})
export class LeavePromoDetailPageModule {}
